import { FeatureData } from "views/components/Schedules/components/UpdateActivityPopup/styles";

const SpaceFeatureData = ({
    minCapacity, maxCapacity, 
    address, reference
}) => {
    // Test
    //address = "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Numquam quidem similique cumque! Voluptatum, cum sunt.";
    return (
        <FeatureData>
            <p>Aforo: {minCapacity} - {maxCapacity}</p>
            <p className="ellipsis" title={address}>Dirección: {address}</p>
            <p className="multiline-ellipsis" title={reference}>Referencia: {reference}</p>
        </FeatureData>
    );
}

export default SpaceFeatureData;